var render = function render(){var _vm=this,_c=_vm._self._c;return _c('profile-view-template',{attrs:{"name":_vm.name},scopedSlots:_vm._u([{key:"additionalContent",fn:function(){return [_c('profile-access-requests-row')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }